import axios from "axios";
import { shipmentService } from "../../services";
import { cartConstants, shipmentConstant } from "../constants";
import { apiUrl } from "../../constant";

export const getEmployeeAddressById = (id, addressType) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.getEmployeeAddressById(id, addressType).then(
                (result) => {
                    let empAddress = { ...result.data.Entity };
                    dispatch(getEmployeeAddressByIdSuccess(empAddress));
                    return resolve(empAddress);
                },
                (error) => {
                    return reject(new Error(error?.message || "Failed to fetch employee address"));
                }
            );
        });
    };
};

export const getSellerAddressById = (sellerId) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.getSellerAddressByIdService(sellerId).then(
                (result) => {
                    let empAddress = { ...result.data.Entity };
                    dispatch(getEmployeeAddressByIdSuccess(empAddress));
                    return resolve(empAddress);
                },
                (error) => {
                    return reject(new Error(error?.message || "Failed to fetch seller address"));
                }
            );
        });
    };
};

export const resetServices = () => {
    return {
        type: shipmentConstant.RESET_CARRIERS,
    };
};

export const getAllServicesSuccess = (response) => ({
    type: shipmentConstant.GET_ALL_SERVICES_SUCCESS,
    payload: response,
});

export const getAllServices = (isInternational, isMilitary) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.getAllServices(isInternational, isMilitary).then(
                (result) => {
                    let services = [];
                    if (result?.data && Array.isArray(result.data.EntityList)) {
                        services = [...result.data.EntityList];
                    } else if (result?.data?.EntityList) {
                        console.warn('getAllServices: EntityList is not an array:', result.data.EntityList);
                    }
                    dispatch(getAllServicesSuccess(services));
                    return resolve(services);
                },
                (error) => {
                    console.error('getAllServices error:', error);
                    return reject(new Error(error?.message || "Failed to fetch services"));
                }
            );
        });
    };
};

export const getAllPackagesByServiceId = (serviceId) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.getAllPackagesByServiceId(serviceId).then(
                (result) => {
                    let services = [...result.data.EntityList];
                    dispatch(getAllPackagesByServiceIdSuccess(services));
                    return resolve(services);
                },
                (error) => {
                    return reject(new Error(error?.message || "Failed to fetch packages"));
                }
            );
        });
    };
};

export const getAllCountries = () => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.getAllCountries().then((result) => {
                let countries = [...result.data.EntityList];
                dispatch(getAllCountriesSuccess(result.data.EntityList));
                return resolve(countries);
            },
                (error) => {
                    return reject(new Error(error?.message || "Failed to fetch countries"));
                }
            );
        });
    };
};

export const createShipment = (shipment) => {
    return () => {
        return shipmentService.createShipment(shipment);
    };
};

export const getEmployeeAddressByIdSuccess = (response) => ({
    type: shipmentConstant.GET_EMPLOYEE_ADDRESS_BY_ID_SUCCESS,
    payload: response,
});

export const getAllPackagesByServiceIdSuccess = (response) => ({
    type: shipmentConstant.GET_ALL_PACKAGES_BY_SERVICE_ID_SUCCESS,
    payload: response,
});

export const getAllCountriesSuccess = (response) => ({
    type: shipmentConstant.GET_ALL_COUNTRIES_SUCCESS,
    payload: response,
});

export const editShipment = (response) => ({
    type: shipmentConstant.EDIT_SHIPMENT_SUCCESS,
    payload: response,
});

export const getStatesSuccess = (response) => ({
    type: shipmentConstant.GET_STATES_SUCCESS,
    payload: response,
});

export const getStates = (countryId) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.getAllUnitesStates(countryId).then(
                (result) => {
                    if (result?.data?.EntityList) {
                        let states = [...result.data.EntityList];
                        dispatch(getStatesSuccess(states));
                        resolve(states);
                    } else {
                        // Handle the case where EntityList is null or undefined
                        resolve([]);
                    }
                },
                (error) => {
                    return reject(new Error(error?.message || "Failed to fetch states"));
                }
            );
        });
    };
};

export const getActiveCSVList = (response) => ({
    type: shipmentConstant.GET_ACTIVE_CSV_LIST,
    payload: response,
});

export const getCsvActiveIntegration = (createdBy) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.csvActiveIntegration(createdBy).then(
                (result) => {
                    let list = result?.data?.EntityList;
                    dispatch(getActiveCSVList(list));
                    return resolve(list);
                },
                (error) => {
                    return reject(new Error(error?.message || "Failed to fetch CSV active integration"));
                }
            );
        });
    };
};

export const uploadCsv = (data) => {
    return () => {
        return shipmentService.uploadCsvFile(data);
    };
};

export const updateSkipDuplicate = (data) => {
    return () => {
        return shipmentService.updateSkipDuplicateService(data);
    };
};

export const deleteOrder = (data) => {
    return new Promise((resolve, reject) => {
        return resolve(shipmentService.deleteOrderService(data));
    });
};

export const deleteFileMaster = (orderId, data) => {
    return () => {
        return shipmentService.deleteFileMasterService(orderId, data);
    };
};
export const deleteIntegration = (orderId, data) => {
    return () => {
        return shipmentService.deleteIntegrationService(orderId, data);
    };
};

const loadShipmentsAction = (response) => ({
    type: shipmentConstant.GET_SHIPMENT_LIST,
    payload: response,
});

export const loadShipments = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.getShipmentsService(data).then(
                (result) => {
                    let list = result.data.EntityList;
                    dispatch(loadShipmentsAction(list));
                    return resolve(list);
                },
                (error) => {
                    return reject(new Error(error?.message || "Failed to fetch shipments"));
                }
            );
        });
    };
};

export const loadShipmentsBatch = (data) => {
    return () => {
        return shipmentService.getShipmentsService(data);
    };
};

export const saveShipmentDraft = (data) => {
    return () => {
        return shipmentService.saveShipmentsService(data);
    };
};

export const updateAddress = (data) => {
    return new Promise((resolve, reject) => {
        return resolve(shipmentService.updateAddressService(data));
    });
};

export const updateBulkOrder = (data) => {
    return new Promise((resolve, reject) => {
        return resolve(shipmentService.updateBulkOrderService(data));
    });
};

export const getShipmentById = (data) => {
    return axios.get(`${apiUrl}/api/Shipment/LoadShipmentById?${data}`);
};

export const getZipZonerates = (data, userId) => {
    return () => {
        return shipmentService.getZipZoneratesService(data, userId);
    };
};

export const getZipZoneRatesByServiceType = (data) => {
    return () => {
        return shipmentService.getZipZoneRateByServiceTypeService(data);
    };
};

export const deleteShipment = (data) => {
    return () => {
        return shipmentService.deleteShipmentService(data);
    };
};

export const getAllCarrierSuccess = (response) => ({
    type: shipmentConstant.GET_ALL_CARRIER_SUCCESS,
    payload: response,
});

export const getAllCarrierServices = (sortData) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.fetchAllCarriers(sortData).then(
                (result) => {
                    let services = result.data.EntityList;
                    dispatch(getAllCarrierSuccess(services));
                    return resolve(services);
                },
                (error) => {
                    return reject(new Error(error?.message || "Failed to fetch carriers"));
                }
            );
        });
    };
};

/** Fetch services */

export const getAllCarrierServicesSuccess = (response) => ({
    type: shipmentConstant.GET_ALL_CARRIER_SERVICES_SUCCESS,
    payload: response,
});

export const getAllCarrierServicesList = () => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.fetchAllCarrierServices().then(
                (result) => {
                    let services = result.data.EntityList;
                    dispatch(getAllCarrierServicesSuccess(services));
                    return resolve(services);
                },
                (error) => {
                    return reject(new Error(error?.message || "Failed to fetch carrier services"));
                }
            );
        });
    };
};

export const updateCarrierStatus = (data) => {
    return new Promise((resolve, reject) => {
        return resolve(shipmentService.updateCarrierStatusService(data));
    });
};

export const getAllSellerCarriersSuccess = (response) => ({
    type: shipmentConstant.GET_ALL_SELLER_CARRIER_SUCCESS,
    payload: response,
});

export const getAllSellerCarriersPending = () => ({
    type: shipmentConstant.GET_ALL_SELLER_CARRIER_PENDING,
});

export const getAllSellerCarriersFailed = () => ({
    type: shipmentConstant.GET_ALL_SELLER_CARRIER_FAILED,
});

export const getAllSellerCarriers = (sortData) => {
    return (dispatch) => {
        dispatch(getAllSellerCarriersPending());
        shipmentService.getSellerCarrierListService(sortData).then((result) => {
            dispatch(getAllSellerCarriersSuccess(result.data));
        }).catch(() => {
            dispatch(getAllSellerCarriersFailed());
        });
    };
};

//get sellers

export const getSellerByCompanySuccess = (response) => ({
    type: shipmentConstant.GET_ALL_COMPANY_SELLER_SUCCESS,
    payload: response,
});

export const getSellerCarriersForCompany = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.getSellerCarriersForCompanyService(data).then(
                (result) => {
                    let carriers = result.data.EntityList;
                    dispatch(getSellerByCompanySuccess(carriers));
                    return resolve(carriers);
                },
                (error) => {
                    return reject(new Error(error?.message || "Failed to fetch seller carriers"));
                }
            );
        });
    };
};

export const updateSellerCarriers = (data) => {
    return new Promise((resolve, reject) => {
        return resolve(shipmentService.updateSellerCarriersService(data));
    });
};

export const fetchAddressFromZipCode = (data) => {
    return () => {
        return shipmentService.getAddressFromZipCodeService(data);
    };
};

export const fetchAddressByZip = (zipCode) => {
    return axios.get(`${apiUrl}/GetZipCode?searchString=${zipCode}`);
};

export const resetSellerByCompany = (response) => ({
    type: shipmentConstant.RESET_COMPANY_SELLER_LIST,
    payload: response,
});

export const getOrderByIntegrationId = (data) => {
    return () => {
        return shipmentService.getOrderByIntegrationIdService(data);
    };
};

export const getPendingOrders = (data) => {
    return () => {
        return shipmentService.getPendingOrdersService(data);
    };
};

export const signatureListSuccess = (response) => ({
    type: shipmentConstant.GET_SIGNATURE_LIST,
    payload: response,
});

export const getSignatureOptionList = (serviceId) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.getSignatureListService(serviceId).then(
                (result) => {
                    let list = result.data.EntityList;
                    dispatch(signatureListSuccess(list));
                    return resolve(list);
                },
                (error) => {
                    return reject(new Error(error?.message || "Failed to fetch signature options"));
                }
            );
        });
    };
};

export const contentTypeListSuccess = (response) => ({
    type: shipmentConstant.GET_CONTENT_TYPE_LIST,
    payload: response,
});

export const getContentTypeListService = (carriercompanyid) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.getContentTypeListService(carriercompanyid).then(
                (result) => {
                    let list = result.data.EntityList;
                    dispatch(contentTypeListSuccess(list));
                    return resolve(list);
                },
                (error) => {
                    return reject(new Error(error?.message || "Failed to fetch content types"));
                }
            );
        });
    };
};

export const getDimensionUnitsSuccess = (response) => ({
    type: shipmentConstant.GET_DIMENSION_UNIT_LIST,
    payload: response,
});

export const getDimensionUnitList = () => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.getDimensionUnitService().then((res) => {
                dispatch(getDimensionUnitsSuccess(res.data.EntityList));
                resolve(res);
            }).catch((err) => {
                return reject(new Error(err?.message || "Failed to fetch content types"));
            });
        })
    };
};

export const getWeightUnitsSuccess = (response) => ({
    type: shipmentConstant.GET_WEIGHT_UNIT_LIST,
    payload: response,
});

export const getWeightUnitList = () => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return shipmentService.getWeightUnitService().then((res) => {
                dispatch(getWeightUnitsSuccess(res.data.EntityList));
                resolve(res);
            }).catch((err) => {
                return reject(new Error(err?.message || "Failed to fetch weight units"));
            });
        })
    };
};

export const csvUploadListBackDetails = (data) => ({
    type: shipmentConstant.CSV_UPLOAD_LIST_BACK_DETAILS,
    payload: data,
});

export const addToCart = (data) => ({
    type: cartConstants.ADD_TO_CART_LIST,
    payload: data,
});

export const getRecaptchaKey = () => {
    return axios.get(`${apiUrl}/GetRecaptchaKey`);
};

export const getSignupReasons = () => {
    return axios.get(`${apiUrl}/api/get_all_signup_reason`);
};
